import React from "react";
import { Box, Typography } from "@mui/material";

import { WEB_URL } from "../api/URLs";
import { MixPanelTrackedLink } from "../components";
import AboutUsCover1 from "../assets/images/home5.jpg";
import AboutUsCover2 from "../assets/images/home6.jpg";
import AboutUsCover3 from "../assets/images/home7.jpg";
import AboutUsCover4 from "../assets/images/home8.jpg";
import AboutUsIcon1 from "../assets/icons/home-icon1.svg";
import AboutUsIcon2 from "../assets/icons/home-icon2.svg";
import AboutUsIcon3 from "../assets/icons/home-icon3.svg";
import AboutUsIcon4 from "../assets/icons/home-icon4.svg";
import { GTM_EVENTS, SUPPORTER_DESCRIPTION } from "../constants";
import { StyledGetInspiredCard } from "./StyledComponents/GetInspiredCardStyles";

export function GetInspiredCards() {
    const specifications = [
        { backColor: '#8CC63F', coverImage: AboutUsCover1, description: SUPPORTER_DESCRIPTION[0], icon: AboutUsIcon1 },
        { backColor: '#FEC300', coverImage: AboutUsCover2, description: SUPPORTER_DESCRIPTION[1], icon: AboutUsIcon2 },
        { backColor: '#F39200', coverImage: AboutUsCover3, description: SUPPORTER_DESCRIPTION[2], icon: AboutUsIcon3 },
        { backColor: '#008C44', coverImage: AboutUsCover4, description: SUPPORTER_DESCRIPTION[3], icon: AboutUsIcon4 },
    ]

    const mapCards = () => {
        return specifications.map((object, index) => {
            return <Box className="Card" sx={{ backgroundColor: object.backColor }} key={index}>
                <MixPanelTrackedLink className="ImageButton" type="link" label="Image" context="Cover image on 'Get Inspired' section" gtmEvent={GTM_EVENTS.START_FUNDRAISER_CLICKED} href={WEB_URL.CREATE_FUNDRAISER}>
                    <img className="CoverImage" src={object.coverImage} />
                </MixPanelTrackedLink>
                <Box>

                    <Typography gutterBottom className="SupporterDescription">{object.description}
                    </Typography>
                    <img src={object.icon} className="Icon" />
                </Box>
            </Box>
        })
    }

    return <StyledGetInspiredCard className="GetInspiredCards" justifyContent='space-between' direction={{ xs: 'column', md: 'row' }}>
        {mapCards()}
    </StyledGetInspiredCard>
}